import { COMMENTS_FETCH_SUCCESS } from '../constant/actionType';

const initialState = {
  comments: [],
  isLoaded: false
};

const commentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMMENTS_FETCH_SUCCESS:
      return {
        ...state,
        comments: action.data,
        isLoaded: true
      };
    default:
      return state;
  }
};

export default commentsReducer;
